import { ImaAdPlayer } from 'src/adPlayers/ima';
import { start } from 'src/main';
import { VJsPlayer } from 'src/players/video-js';

start(VJsPlayer, ImaAdPlayer);
